import type { ReactNode } from 'react';

export const symbol_auto_stories_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M460-175q-45-31-95.5-48T260-240q-42 0-82.5 11T100-198q-21 11-40.5-1T40-234v-482q0-11 5.5-21T62-752q11-5 21-9.5t21-9.5l-44-44q-9-9-9-21t9-21q9-9 21-9t21 9L869-90q9 9 9 21t-9 21q-9 9-21 9t-21-9L641-234q-38 7-73.5 22T500-175q-9 6-20 6t-20-6Zm-40-89v-191L151-724q-14 5-27 9.5T100-704v440q35-17 75.5-26.5T260-300q45 0 85 9.5t75 26.5Zm60-302L246-800q56-2 110 10.5T459-751q10 5 15.5 14t5.5 20v151Zm0 332q26-17 53.5-30t56.5-21L480-395v161Zm156-176-96-96v-149q0-12 5-23.5t13-19.5l191-191q14-14 32.5-6.5T800-868v288q0 13-5.5 25T779-535L636-410Zm224 212-98-98q25 4 50 11.5t48 20.5v-459q0-15 9.5-22t20.5-7q11 0 20.5 7.5T920-723v489q0 23-19.5 35t-40.5 1Zm-440-66v-191 191Z"
		/>
	</svg>
);
